module.exports = __webpack_public_path__ + "static/media/T-shirt_golden.f500606a.svg";